import { RESET_STATE } from 'store/global/actions';
import { LOAN_APPLICATION_PROPERTIES_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = null;

const loanApplicationPropertiesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_APPLICATION_PROPERTIES_ACTION_TYPE.GET_PROPERTIES: {
      return payload || initialState;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanApplicationPropertiesReducer;
